<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="despacho.tipo.tipo_condicion && estados.tipo_condicion"
      class="grid grid-cols-5 gap-4"
    >
      <div>
        <p>Tipo Condición</p>
      </div>
      <div class="col-span-3 text-right font-bold uppercase">
        <p v-if="despacho.tipo.tipo_condicion">
          {{ despacho.tipo.tipo_condicion }}
        </p>
        <p v-else>-</p>
      </div>
      <div class="mx-auto">
        <button
          v-if="pantalla == true"
          class="btn-principal"
          @click="editar('tramitador_aduanero', 'tipo_condicion')"
        >
          Editar
          <fas :icon="['fas', 'edit']" />
        </button>
        <button
          v-if="pantalla == false"
          @click="editar('tramitador_aduanero', 'tipo_condicion')"
          class="btn-principal-chico"
        >
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/EditarAzul.svg"
            title="My Image"
          />
        </button>
      </div>
    </div>
    <div v-else class="grid grid-cols-2 gap-4 p-4">
      <div>
        <label>Tipo Condición</label>
        <select id="condicion-select" v-model="condicion" required>
          <option value="0" disabled>Selecciona la Condición</option>
          <option
            :key="index"
            v-for="(tipo_condicion, index) in informacionGeneral.tipo_condicion"
            :value="tipo_condicion"
          >
            {{ tipo_condicion }}
          </option>
        </select>
      </div>
      <div class="flex flex-row gap-2 mt-auto">
        <button
          class="btn-principal"
          type="button"
          @click="
            editar('tramitador_aduanero', 'tipo_condicion', true, {
              tipo_condicion: condicion,
            })
          "
        >
          Guardar
        </button>
        <button
          class="btn-secundario"
          type="button"
          @click="editar('tramitador_aduanero', 'tipo_condicion')"
        >
          Cancelar
        </button>
      </div>
    </div>
    <!--EXTRAPORTUARIO-->

    <div
      v-if="despacho.tipo.extraportuario && estados.extraportuario"
      class="grid grid-cols-5 gap-4"
    >
      <div class="">
        <p>Puerto/Extraportuario</p>
      </div>
      <div class="col-span-3 text-right font-bold uppercase">
        <p v-if="despacho.tipo.extraportuario">
          {{ despacho.tipo.extraportuario.nombre }}
        </p>
        <p v-else>-</p>
      </div>
      <div class="mx-auto">
        <button
          v-if="pantalla == true"
          @click="editar('tramitador_aduanero', 'extraportuario')"
          class="btn-principal"
        >
          Editar
          <fas :icon="['fas', 'edit']" />
        </button>
        <button
          v-if="pantalla == false"
          @click="editar('tramitador_aduanero', 'extraportuario')"
          class="btn-principal-chico"
        >
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/EditarAzul.svg"
            title="My Image"
          />
        </button>
      </div>
    </div>
    <div v-else class="grid grid-cols-2 gap-4 p-4">
      <div>
        <label>Puerto/Extraportuario</label>
        <select id="extraportuario-select" v-model="extraportuario" required>
          <option value="0" disabled>
            Selecciona un Puerto/Extraportuario
          </option>
          <option
            :key="index"
            v-for="(
              extraportuario, index
            ) in informacionGeneral.extraportuarios"
            :value="extraportuario.id"
          >
            {{ extraportuario.nombre }}
          </option>
        </select>
      </div>
      <div class="flex flex-row gap-2 mt-auto">
        <button
          class="btn-principal"
          type="button"
          @click="
            editar('tramitador_aduanero', 'extraportuario', true, {
              extraportuario_id: extraportuario,
            })
          "
        >
          Guardar
        </button>
        <button
          class="btn-secundario"
          type="button"
          @click="editar('tramitador_aduanero', 'extraportuario')"
        >
          Cancelar
        </button>
      </div>
    </div>
    <div
      v-if="despacho.tipo_inspeccion_aforo && estados.aforo"
      class="grid grid-cols-5 gap-4"
    >
      <div class="">
        <p>Tipo de inspección de Aforo</p>
      </div>
      <div class="col-span-3 font-bold uppercase text-right">
        <p>{{ despacho.tipo_inspeccion_aforo?.nombre ?? "-" }}</p>
      </div>
      <div class="mx-auto">
        <button
          @click="editar('tramitador_aduanero', 'aforo')"
          class="btn-principal"
          disabled
        >
          Editar
          <fas :icon="['fas', 'edit']" />
        </button>
      </div>
    </div>
    <div v-else class="grid grid-cols-2 gap-4 p-4">
      <div>
        <label>Tipo de Aforo</label>
        <select id="aforo-select" v-model="aforo" required>
          <option value="3" disabled>Selecciona el Tipo de Aforo</option>
          <option value="2">Sin Aforo</option>
          <option value="1">Examen Físico</option>
          <option value="0">Examen Documental</option>
        </select>
      </div>
      <div class="flex flex-row gap-2 mt-auto">
        <button
          class="btn-principal"
          type="button"
          @click="
            editar('tramitador_aduanero', 'aforo', true, {
              aforo: aforo,
            })
          "
        >
          Guardar
        </button>
        <button
          class="btn-secundario"
          type="button"
          @click="editar('tramitador_aduanero', 'aforo')"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  data() {
    return {
      condicion: 0,
      extraportuario: "",
      aforo: "0",
      pantalla: false,
    };
  },
  mounted() {
    this.aforo = this.despacho?.aforo.toString()
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;
  },
  methods: {},
};
</script>
